import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';

import Settings from "../containers/Settings";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";
import UserProfile from "../containers/UserProfile";
import SourcesSettings from '../containers/SourcesSettings';

function SettingsRouter(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);
	let {updateHeader, resetHeader, showSnackbar, setBannerClassName, hasNudgeBanner,
			updateUser, banner, bannerHeight, showBanner, evictUser, setFullScreenClassName} = props,
		routes = SettingsRouter.getRoutes();

	return (
		<Switch>
			<Redirect
				exact
				from={routes[0]}
				to={routes[1]} />
			<Route
				path={routes[1]}
				render={renderProps =>
					<Settings
						{...renderProps}
						updateUser={updateUser}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar}
						banner={banner}
						bannerHeight={bannerHeight}
						showBanner={showBanner}
						hasNudgeBanner={hasNudgeBanner}
						setBannerClassName={setBannerClassName}
						setFullScreenClassName={setFullScreenClassName} />
				} />

			{AuthorizedUser.hasTeam(authenticatedUser) ?
				<Route
					path={routes[2]}
					render={renderProps =>
						<Settings
							{...renderProps}
							updateUser={updateUser}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							banner={banner}
							bannerHeight={bannerHeight}
							showBanner={showBanner}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[2]}
					to="/no-access" />
			}

			{AuthorizedUser.hasLocations(authenticatedUser) ?
				<Route
					path={routes[3]}
					render={renderProps =>
						<Settings
							{...renderProps}
							updateUser={updateUser}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							banner={banner}
							bannerHeight={bannerHeight}
							showBanner={showBanner}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[3]}
					to="/no-access" />
			}

			<Route
				path={routes[4]}
				render={renderProps =>
					<UserProfile
						{...renderProps}
						banner={banner}
						showBanner={showBanner}
						updateUser={updateUser}
						evictUser={evictUser}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar}
						setBannerClassName={setBannerClassName} />
				} />
			{AuthorizedUser.isAdmin(authenticatedUser) && authenticatedUser.isFreemium?
				<Route
					path={routes[5]}
					render={renderProps =>
						<SourcesSettings
							{...renderProps}
							banner={banner}
							showBanner={showBanner}
							updateUser={updateUser}
							evictUser={evictUser}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							setBannerClassName={setBannerClassName} />
					} />
				:
				<Redirect
					from={routes[5]}
					to="/no-access" />
			}
		</Switch>
	);
}

SettingsRouter.getRoutes = () => {
	const routes = [
		"/settings",
		"/settings/general",
		"/settings/team",
		"/settings/locations",
		"/profile/:userId",
		"/settings/sources",		
	];
	return routes;
};

SettingsRouter.propTypes = {
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
	setBannerClassName: PropTypes.func,
	hasNudgeBanner: PropTypes.bool,
	banner: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	bannerHeight: PropTypes.number,
	showBanner: PropTypes.func.isRequired,
	updateUser: PropTypes.func.isRequired,
	evictUser: PropTypes.func.isRequired,
	setFullScreenClassName: PropTypes.func
};

export default SettingsRouter;